// Story 6.9 (ADO-1163, AC3) — Card container. Presentational panel used across
// My Account and Admin screens.

import type { ReactNode } from 'react';
import styles from './Card.module.css';

export interface CardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  /** Right-side header slot (e.g. a "Create User" button or a badge). */
  headerAction?: ReactNode;
  children: ReactNode;
  className?: string;
}

export function Card({ title, subtitle, headerAction, children, className }: CardProps) {
  return (
    <section className={[styles.card, className].filter(Boolean).join(' ')}>
      {title || headerAction ? (
        <div className={styles.header}>
          <div>
            {title ? <h2 className={styles.title}>{title}</h2> : null}
            {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
          </div>
          {headerAction}
        </div>
      ) : null}
      {children}
    </section>
  );
}
